<template>
    <div>
        <div class="vertical-align-wrap" style="z-index: 2">
            <div class="vertical-align-top" style="z-index: 2;height: 100%">
                <div class="auth-box row">
                    <div class="left">
                        <div class="content">
                            <div class="logo text-center pb-3">
                                <img src="@/assets/img/logo-tosca.png" alt="logo" style="width: 100%;height: auto;">
                            </div>
                            <span style="display:none">Masuk menggunakan akun</span>
                            <div class="row mt-3 mb-5" style="display:none">
                                <div class="col-sm-6" style="text-align: right;">
                                    <button v-on:click="loginWithGoogle" type="button" class="btn link" style="min-width: 150px; min-height: 47px">
                                        <svg width="133" height="32" viewBox="0 0 133 32" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <rect x="52" width="28" height="28" fill="url(#pattern0)" />
                                            <defs>
                                                <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                    <use xlink:href="#image0" transform="translate(0 -0.00662252) scale(0.00662252)" />
                                                </pattern>
                                                <image id="image0" width="151" height="153" xlink:href="data:image/png;base64,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" />
                                            </defs>
                                        </svg>
                                    </button>
                                </div>
                                <div class="col-sm-6" style="text-align: left;">
                                    <button type="button" class="btn btn-info" style="min-width: 150px; min-height: 47px">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M27.5 3.5H4.5C3.94687 3.5 3.5 3.94687 3.5 4.5V27.5C3.5 28.0531 3.94687 28.5 4.5 28.5H27.5C28.0531 28.5 28.5 28.0531 28.5 27.5V4.5C28.5 3.94687 28.0531 3.5 27.5 3.5ZM24.6125 10.7969H22.6156C21.05 10.7969 20.7469 11.5406 20.7469 12.6344V15.0437H24.4844L23.9969 18.8156H20.7469V28.5H16.85V18.8188H13.5906V15.0437H16.85V12.2625C16.85 9.03437 18.8219 7.275 21.7031 7.275C23.0844 7.275 24.2688 7.37813 24.6156 7.425V10.7969H24.6125Z" fill="white"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <span style="display:none">--- ATAU ---</span>
                            <div class="header">
                                <p class="lead"></p>
                            </div>
                            <form class="form-auth-small pt-3" action="" @submit="submitLogin" method="post">
                                <div class="alert alert-danger" v-if="failed">{{ failedMsg }}</div>
                                <div class="form-group">
                                    <label for="signin-email" class="control-label sr-only">Email</label>
                                    <input type="text" class="form-control" name="login" id="signin-email" required placeholder="Email" v-model="form.username">
                                    <input name="log-me-in" type="hidden" value="1">
                                </div>
                                <div class="form-group">
                                    <label for="signin-password" class="control-label sr-only">Sandi</label>
                                    <div class="input-group">
                                        <input type="password" name="password" id="signin-password" required class="form-control" data-toggle="password" placeholder="Sandi" v-model="form.password">
                                        <div class="input-group-append">
                                            <span class="input-group-text input-password-hide" style="cursor: pointer;">
                                                <i class="fa fa-eye"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group clearfix">
                                    <label class="fancy-checkbox element-left">
                                        <input type="checkbox" name="remember_me" value="1">
                                        <span>Selalu ingat</span>
                                    </label>
                                </div>
                                <button type="submit" class="btn btn-primary btn-lg btn-block mb-1 submit"><span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{{ loading?" Sign In...":"Login Sekarang" }} <i class="fa fa-sign-in-alt"></i></button>
                                <div class="bottom">
                                    <div class="row mb-3" style="width: 100%">
                                        <span class="helper-text" style="width: 100%">
                                            <router-link to="/register" style="color: grey">Daftar baru</router-link>
                                        </span>
                                    </div>
                                    <div class="row" style="width: 100%">
                                        <span class="helper-text" style="width: 100%"><a href="" style="color: grey">Lupa sandi?</a> </span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="right">
                        <!-- <div class="overlay"></div> -->
                        <div id="demo" class="carousel slide" data-ride="carousel" data-interval="false" data-pause="hover">
                            <!-- Indicators -->
                            <ul class="carousel-indicators">
                                <li data-target="#demo" data-slide-to="0" class="active"></li>
                                <li data-target="#demo" data-slide-to="1"></li>
                                <li data-target="#demo" data-slide-to="2"></li>
                                <li data-target="#demo" data-slide-to="3"></li>
                            </ul>
                            <!-- The slideshow s1.jpg-->
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <img src="@/assets/img/welcome-1.png" class="d-block w-100" alt="Los Angeles">
                                </div>
                                <div class="carousel-item">
                                    <img src="@/assets/img/s2.jpg" class="d-block w-100" alt="Chicago">
                                </div>
                                <div class="carousel-item">
                                    <img src="@/assets/img/s3.jpg" class="d-block w-100" alt="New York">
                                </div>
                                <div class="carousel-item">
                                    <img src="@/assets/img/s4.jpg" class="d-block w-100" alt="New York">
                                </div>
                            </div>
                            <!-- Left and right controls -->
                            <a class="carousel-control-prev" href="#demo" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#demo" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a>
                        </div>
                        <!-- <div class="clearfix"></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { auth } from '@/libs/hxcore';
import $ from 'jquery';
//import '@/assets/login.css';
export default {
    name: 'Login',
    data() {
        return {
            errors: [],
            loading: false,
            failed: false,
            failedMsg: '',
            form: {
                username: '',
                password: ''
            }
        }
    },
    methods: {
        submitLogin: function(e) {
            if (this.form.username && this.form.password) {
                var data = Object.keys(this.form).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.form[key])).join('&')
                this.loading = true;
                this.failed = false;
                fetch(window.$apiUrl + '/login', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: data
                    })
                    .then(res => {
                        this.loading = false;
                        if (res.status === 201) {

                        } else if (res.status === 400) {
                            //let errorResponse = await res.json();
                            //this.errors.push(errorResponse.error);
                        }
                        return res.json();
                    })
                    .then(js => {
                        if (js.status) {
                            localStorage['branch_id'] = '';
                            auth.login(js);
                            this.$router.push('/home');
                        } else {
                            this.failed = true;
                            this.failedMsg = js.message;
                        }
                        console.log(js)
                    });
            }


            e.preventDefault();
        },
        loginWithGoogle() {
            this.$gAuth
                .signIn()
                .then(GoogleUser => {
                    // on success do something
                    console.log('GoogleUser', GoogleUser)
                    var userInfo = {
                        loginType: 'google',
                        google: GoogleUser
                    }
                    this.$store.commit('setLoginUser', userInfo)
                    localStorage['branch_id'] = '';
                    router.push('/home')
                })
                .catch(error => {
                    console.log('error', error)
                })
        }

    }
}
$(function() {
    $('[data-toggle="password"]').each(function() {
        var input = $(this);
        var eye_btn = $(this).parent().find('.input-group-text');
        eye_btn.css('cursor', 'pointer').addClass('input-password-hide');
        eye_btn.on('click', function() {
            if (eye_btn.hasClass('input-password-hide')) {
                eye_btn.removeClass('input-password-hide').addClass('input-password-show');
                eye_btn.find('.fa').removeClass('fa-eye').addClass('fa-eye-slash')
                input.attr('type', 'text');
            } else {
                eye_btn.removeClass('input-password-show').addClass('input-password-hide');
                eye_btn.find('.fa').removeClass('fa-eye-slash').addClass('fa-eye')
                input.attr('type', 'password');
            }
        });
    });

    setInterval(function() {
        // $('[data-slide="next"]').click();
    }, 5000);
});
</script>
<style scoped src="../assets/login.css"></style>
<style scoped>
.widget-block {
    height: 100%;
}

.split-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none
        /*table*/
    ;
    background-color: #21316F;
    /*background-image: url(../../assets/img/repeat-bg.jpg);*/
    background-repeat: repeat repeat;
    z-index: 1;
}

.w-100-1 {}

.carousel-indicators .active {
    height: 6px;
    width: 30px;
    background-color: grey;
}

.vertical-align-wrap {
    background-color: transparent;
    background-image: none;
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
    height: 100%;
}

.auth-box {
    border-radius: 15px;
    width: 100%;
    height: 100%;
    /*height: 600px*/
}

.carousel-indicators li {
    border-top: none;
    border-bottom: none;
    height: 8px;
    display: inline-block;
    /*background-color: darkgray;*/
    background: linear-gradient(90deg, #EC008C 50%, #FC6767 100%);
    width: 8px;
    border-radius: 20px;
}

.carousel-inner {
    height: 100%;
    /*border-radius: 0px 15px 15px 0px;*/
}

.carousel-indicators {
    display: block;
    text-align: center;
    width: 70%;
}

.carousel-indicators .active {
    background: #AFAFAF;
    height: 8px;
}

.carousel-caption {
    bottom: auto;
    /*margin-top: -30px;*/
    vertical-align: middle;
}

.right-side {
    float: right;
    width: 60%;
    height: 100%;
    position: relative;
}

.auth-box .right {
    float: right;
    width: 60%;
    height: 100vh;
    position: relative;
    background: none;
    border-radius: 15px;
    /*background-image: url(../../assets/img/login-bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;*/
}

.auth-box .right:before {
    display: contents;
}

.auth-box .left {
    float: left;
    width: 40%;
    height: 100vh;
    padding: 0 60px;
    text-align: center;
}

@media screen and (max-width: 1023px) {
    .auth-box .left {
        width: 100%;
        position: inherit;
        padding: 50px;
    }

    .split-bg {
        display: none;
    }

    .vertical-align-wrap {
        /*background-color: #21316F;*/
        /*background-image: url(../../assets/img/repeat-bg.jpg);*/
        background-repeat: repeat repeat;
        z-index: 1;
    }
}

@media screen and (max-width: 1279px) {
    .auth-box .left {
        top: 3.3em;
    }

    .split-bg {
        display: none;
    }

    .vertical-align-wrap {
        /*background-color: #21316F;*/
        /*background-image: url(../../assets/img/repeat-bg.jpg);*/
        background-repeat: repeat repeat;
        z-index: 1;
    }
}

.carousel {
    height: 100%;
    background: rgb(237, 237, 237);
    background: linear-gradient(261deg, rgba(237, 237, 237, 0) 44%, rgba(31, 174, 203, 0.23713235294117652) 100%);
}

.carousel-inner img {
    height: 100%;
    width: 100%;
    background-size: cover;
    margin-left: auto;
    margin-right: auto;
}

/********************************/
/*            Overlay           */
/********************************/
.overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: #080d15;
    opacity: .5;
}

body {
    color: #676a6d;
}

.form-group {
    margin-bottom: 15px;
}

.form-control {
    height: 34px;
    padding: 6px 12px;
}

.btn-lg {
    padding: 10px 28px;
}

.helper-text {
    text-decoration: none;
    font-size: 14px;
    color: #222D32 !important;
}

.submit {
    border-left:11px #EC008C solid;
    border-right:1px #3A5499 solid;
    border-top:1px #3A5499 solid;
    border-bottom:1px #3A5499 solid;
    background: #3A5499;
}

#demo {
    background: linear-gradient(90deg, #ACB6E5 0%, #86FDE8 100%);
}

</style>